import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack';
import MusicPlayer from './../player/MusicPlayer';
import NavBar from '../navigation/NavBar';
import { ReactComponent as MuvikaLogo } from './../../assets/logo-horiz.svg';
import { ReactComponent as MuvikaLogoPro } from './../../assets/logo-horiz-pro.svg';
import { ReactComponent as MuvikaLogoInv } from './../../assets/logo-horiz-inv.svg';
import { ReactComponent as MuvikaLogoProInv } from './../../assets/logo-horiz-pro-inv.svg';
import muvikaAttrs from './../../attrs';
import { useLocalStorage } from '../../services/useLocalStorage';
import SideBar from '../navigation/SideBar';
import Container from '../views/Container';
import navigationStore from '../../stores/navigation';
import SongbookSideBar from '../navigation/SongbookSideBar';
import SongbookContainer from '../views/SongbookContainer';
import SongbookNavBar from '../navigation/SongbookNavBar';
import SongbookBottomBar from '../navigation/SongbookBottomBar';
import SongbookMobileContainer from '../views/SongbookMobileContainer';
import songbookSessionStore from './../../stores/songbookSession';

function SongbookPortrait() {

  const session = songbookSessionStore((state) => state.session);

  const [theme, setTheme] = useLocalStorage(muvikaAttrs.service + "-songbook-theme", "dark");

  const renderLogo = () => {
    if (session) {
      if (session.account.tags.includes("consumer")) {
        if (!theme || theme === "dark") {
          return <MuvikaLogo className="muvika-logo-svg" />;
        } else {
          return <MuvikaLogoInv className="muvika-logo-svg" />;
        }
      } else {
        if (!theme || theme === "dark") {
          return <MuvikaLogoPro className="muvika-logo-svg" />;
        } else {
          return <MuvikaLogoProInv className="muvika-logo-svg" />;
        }
      }
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <SongbookBottomBar />
      <SongbookNavBar />
      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
      >
        <SongbookMobileContainer isSongbook={true} />
      </Box>
    </Box>
  );
}

export default SongbookPortrait;
